import React from 'react';
import withHeader from "../../hocs/withHeader";
import withFooter from "../../hocs/withFooter";
import {Link} from "react-router-dom";
import {connect} from "react-redux";

function PricingPage(props){

    const premiumCardCss = {
        fontSize : '2em',
        marginBottom : '10%'
    };

    return(
        <section className="pricing">
        <div className="container">
            <h1>Upgrade bubblyPolls</h1>
            <h2>Choose your most suitable pricing plan</h2>
        </div>
        <div className="pricing__container">
            <div className="pricing__item pricing__item--white">
                <div className="pricing__item__top">
                    <span className="pricing__item__top__name">FREE</span>
                    <span className="pricing__item__top__price">$0</span>
                    <span className="pricing__item__top__duration">/month</span>
                    {
                        props.isUserLoggedIn ?
                            <Link to="/" className="pricing__item__top__action">Current plan</Link> :
                            <Link to="/register" className="pricing__item__top__action">Get Started</Link>
                    }
                </div>
                <ul className="pricing__item__list">
                    <li className="pricing__item__list__item">Unlimited surveys</li>
                    <li className="pricing__item__list__item">Template gallery access</li>
                    <li className="pricing__item__list__item">Unlimited respondents</li>
                    <li className="pricing__item__list__item">Web reports, PPT & CSV exports</li>
                    <li className="pricing__item__list__item">Access to all basic question types</li>
                    <li className="pricing__item__list__item">Question logic rules</li>
                </ul>
            </div>
            <div className="pricing__item pricing__item--color">
                <div className="pricing__item__top">
                    <span className="pricing__item__top__name">Premium</span>
                    <span style={premiumCardCss} className="pricing__item__top__price">Request pricing</span>
                    <span className="pricing__item__top__duration"></span>
                    {
                        props.isUserLoggedIn ? <Link className="pricing__item__top__action" to="/contact">Get in touch</Link>
                            : <Link className="pricing__item__top__action" to="/register">Get in touch</Link>
                    }

                </div>
                <ul className="pricing__item__list">
                    <li className="pricing__item__list__item">Everything for your complex research needs </li>
                </ul>
            </div>
            {/*<div className="pricing__item pricing__item--white">*/}
                {/*<div className="pricing__item__top">*/}
                    {/*<span className="pricing__item__top__name">PREMIUM</span>*/}
                    {/*<span className="pricing__item__top__price">$100</span>*/}
                    {/*<span className="pricing__item__top__duration">/month</span>*/}
                    {/*<a href="" className="pricing__item__top__action">Get Started</a>*/}
                {/*</div>*/}
                {/*<ul className="pricing__item__list">*/}
                    {/*<li className="pricing__item__list__item">Unlimited surveys</li>*/}
                    {/*<li className="pricing__item__list__item">Template gallery access</li>*/}
                    {/*<li className="pricing__item__list__item">Unlimited respondents</li>*/}
                    {/*<li className="pricing__item__list__item">PPT, CSV, Web reports</li>*/}
                    {/*<li className="pricing__item__list__item">Template gallery access</li>*/}
                    {/*<li className="pricing__item__list__item">Unlimited surveys</li>*/}
                    {/*<li className="pricing__item__list__item">PPT, CSV, Web reports</li>*/}
                {/*</ul>*/}
            {/*</div>*/}
        </div>
    </section>)
}

function mapStateToProps(state) {
    return {
        isUserLoggedIn: state.user.loggedIn
    };
}

export default connect(mapStateToProps)(withFooter(withHeader(PricingPage)));